import { Award, Flag, Building } from "lucide-react";

const SPEAKER_PORTRAIT = "https://customer-assets.emergentagent.com/job_4077de5f-feb8-4c96-be53-befb95b69eaa/artifacts/cxkdjrlb_EVAGORAS-VRYONIDES.jpg";
const CREDENTIALS_PHOTO = "https://customer-assets.emergentagent.com/job_4077de5f-feb8-4c96-be53-befb95b69eaa/artifacts/hg4iifhg_The%20President%2C%20Droupadi%20Murmu%20accepted%20credentials%20from%20Evagoras%20Vryonides%2C%20High%20Commissioner%20of%20the%20Republic%20of%20Cyprus%20at%20Rashtrapati%20Bhavan%2C%20in%20New%20Delhi%20on%20October%2023%2C%202023..jpg";

const highlights = [
  { icon: Flag, label: "EU Council Presidency", desc: "Represents Cyprus during its landmark Presidency of the Council of the European Union" },
  { icon: Building, label: "Credentials — Rashtrapati Bhavan", desc: "Presented credentials to H.E. Smt. Droupadi Murmu, President of India, New Delhi, 23 October 2023" },
  { icon: Award, label: "EU–India Strategic Architecture", desc: "Leading diplomatic engagement on India-EU FTA, trade policy, and bilateral investment frameworks" },
];

export default function SpeakerSection() {
  return (
    <section id="speaker" data-testid="speaker-section" className="section-dark py-24 lg:py-32 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-16">
          <p className="overline-gold mb-3">Featured Diplomatic Guest</p>
          <div className="gold-divider w-48 mx-auto" />
        </div>

        {/* Main speaker card */}
        <div className="glass-card p-0 overflow-hidden" data-testid="speaker-card">
          <div className="grid lg:grid-cols-2 gap-0">
            {/* Left — Portrait */}
            <div className="relative bg-gradient-to-br from-[#0A1128] to-[#050C1C] flex items-center justify-center p-10 lg:p-14">
              <div className="relative">
                {/* Gold border frame */}
                <div className="absolute -inset-3 border border-[#D4AF37]/25" />
                <div className="absolute -inset-5 border border-[#D4AF37]/10" />
                <img
                  src={SPEAKER_PORTRAIT}
                  alt="H.E. Mr. Evagoras Vryonides"
                  data-testid="speaker-portrait"
                  className="w-56 h-64 lg:w-64 lg:h-72 object-cover object-top relative z-10"
                />
                {/* Cyprus flag badge */}
                <div className="absolute -bottom-3 -right-3 z-20 bg-[#0A1128] border border-[#D4AF37]/30 px-3 py-2 flex items-center gap-2">
                  <img
                    src="https://flagcdn.com/w24/cy.png"
                    alt=""
                    className="h-4 w-auto"
                    onError={(e) => { e.target.style.display = "none"; }}
                  />
                  <span className="text-[#D4AF37] text-[0.6rem] tracking-wider uppercase font-semibold">Cyprus</span>
                </div>
              </div>
            </div>

            {/* Right — Bio */}
            <div className="p-10 lg:p-14 flex flex-col justify-center">
              <p className="overline-gold text-[0.65rem] mb-3">High Commissioner</p>
              <h2 data-testid="speaker-name" className="font-['Cormorant_Garamond'] text-3xl lg:text-4xl font-semibold text-white mb-1">
                H.E. Mr. Evagoras Vryonides
              </h2>
              <p className="text-[#94A3B8] text-sm font-['Outfit'] mb-6">
                Republic of Cyprus &nbsp;·&nbsp; High Commissioner to India
              </p>
              <div className="gold-divider w-32 mb-6" />
              <p className="text-[#CBD5E1] text-sm leading-relaxed font-['Outfit'] mb-8">
                H.E. Mr. Evagoras Vryonides serves as the High Commissioner of the Republic of Cyprus to India, representing Cyprus during its landmark Presidency of the Council of the European Union. Accredited to India with credentials presented to President Smt. Droupadi Murmu at Rashtrapati Bhavan on 23 October 2023, he stands at the forefront of EU–India diplomatic and economic engagement.
              </p>

              {/* Key highlights */}
              <div className="flex flex-col gap-4">
                {highlights.map(({ icon: Icon, label, desc }) => (
                  <div key={label} className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-[#D4AF37]/10 border border-[#D4AF37]/25 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <Icon size={14} className="text-[#D4AF37]" />
                    </div>
                    <div>
                      <p className="text-white text-xs font-semibold font-['Outfit'] uppercase tracking-wider">{label}</p>
                      <p className="text-[#94A3B8] text-xs leading-relaxed mt-0.5">{desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Credentials ceremony photo */}
        <div className="mt-10 glass-card overflow-hidden" data-testid="credentials-card">
          <div className="grid md:grid-cols-3 gap-0">
            <div className="md:col-span-1">
              <img
                src={CREDENTIALS_PHOTO}
                alt="Credentials presented to President of India"
                data-testid="credentials-photo"
                className="w-full h-48 md:h-full object-cover"
              />
            </div>
            <div className="md:col-span-2 p-8 flex flex-col justify-center">
              <p className="overline-gold text-[0.65rem] mb-2">Historic Moment</p>
              <h3 className="font-['Cormorant_Garamond'] text-xl lg:text-2xl text-white font-medium mb-3">
                Credentials Presented to the President of India
              </h3>
              <p className="text-[#94A3B8] text-sm font-['Outfit'] leading-relaxed">
                H.E. Mr. Evagoras Vryonides presenting his credentials to <strong className="text-white">H.E. Smt. Droupadi Murmu</strong>, President of India, at <strong className="text-white">Rashtrapati Bhavan, New Delhi</strong> on <strong className="text-white">23 October 2023</strong> — establishing the highest level of bilateral diplomatic representation between Cyprus and India.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
